//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AuthService from "../../services/AuthService";
import router from "../../router";
import utils from "../../shared/utils";
import ImportProductsDialogWidget from "../../Widgets/ImportProductsDialogWidget.vue";
import ProductTableWidget from "../../Widgets/ProductTableWidget.vue";

export default {
  components: { ImportProductsDialogWidget, ProductTableWidget },
  mixins: ["wrapCsvValue"],
  data() {
    return {
      showPriceCalculationDialog: false,
      publicPath: process.env.BASE_URL,
      existingProducts: 0,
      newProducts: 0,
      hideUploadBtn: true,
      validateResult: undefined,
      validateInProgress: false,
      isImportProductsDialogVisible: false,
    };
  },

  mounted() {
    this.$nextTick(this.focusSearch);
  },

 methods: {
    focusSearch(select = false) {
      const q = this.$refs.searchInput;
      if (q && typeof q.focus === 'function') {
        q.focus();
        const el = typeof q.getNativeElement === 'function'
          ? q.getNativeElement()
          : q.$el?.querySelector('input');
        if (select && el?.select) el.select();
      }
    },

    setProductSearchDisable(val) {
      this.disableProductSearch = val;
      if (!val) this.$nextTick(() => this.focusSearch(true));
    },

    openImportProductsDialog() {
      this.isImportProductsDialogVisible = true;
    },

    onRowClick(row) {
      this.openProduct(row.id);
    },
    openProduct(productId) {
      router.push({
        name: "EditProduct",
        params: { id: productId }
      });
    },

    onEnter() {
      if (this.filter === '') return;
      const products = this.$refs.productTable?.computedRows ?? [];
      if (products.length === 1) {
        this.openProduct(products[0].id);
      } else {
        this.$nextTick(() => this.focusSearch(true));
      }
    },

    onEsc() {
      this.filter = '';
      this.$nextTick(() => this.focusSearch());
    },

    async priceCalcualtionClick(type) {

      var dto = {
        type: type

      };
      await this.runPriceCalculation(dto);
    },

    newProduct() {
      router.push({ name: "EditProduct", params: { id: 0 } });
    },

    test(result) {
      this.newProducts = result.newProducts;
      this.existingProducts = result.existingProducts;

      if (this.newProducts < 100) {
        this.hideUploadBtn = false;
      } else {
        this.$q.notify({
          type: "negative",
          message: this.$t("products.validateFailed")
        });
      }
    },

    checkFileSize(files) {
      this.newProducts = 0;
      this.existingProducts = 0;
      this.hideUploadBtn = true;

      this.validateResult = this.postProductImportValidate(files[0]).then(
        result => {
          this.test(result);
          this.validateInProgress = false;
        }
      );

      this.validateInProgress = true;

      return files;
    },

    onRejected(rejectedEntries) {
      this.$q.notify({
        type: "negative",
        message: `${rejectedEntries.length} file(s) did not pass validation constraints`
      });
    },

    async factoryFn() {
      // var auth = await AuthService.create();
      // var token = await auth.getAccessToken();

      var token = null;
      try {
        token = window.App.$store.getters["main/getUser"]().access_token;

        if (!token) {
          throw new Error();
        }
      } catch {
        var auth = await AuthService.create();
        token = await auth.getAccessToken();
      }

      var baseUrl = (await utils.GetConfig()).API_BASE_URL;
      var url = baseUrl + "/api/Products/Import";

      return new Promise(resolve => {
        resolve({
          url: url,
          method: "POST",
          headers: [{ name: "Authorization", value: `Bearer ${token}` }]
        });
      });
    },

    async refresh() {
      if (this.$refs.productTable && typeof this.$refs.productTable.refresh === 'function') {
        await this.$refs.productTable.refresh();
      }
      this.$nextTick(this.focusSearch);
    },

    async exportProductsClick() {
      const notif = this.$q.notify({
        message: this.$t("common.downloading"),
        timeout: 0,
        spinner: true
      });
      var res = await this.exportProducts();
      notif();

      const url = window.URL.createObjectURL(new Blob([res]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "AvareProductExport.csv");

      document.body.appendChild(link);
      link.click();
    },
    
    ...mapActions("main", [
      "exportProducts",
      "postProductImportValidate",
      "runPriceCalculation"
    ])
  }
};
